import { render } from "./MyListQuotes.vue?vue&type=template&id=0f3a48ce&scoped=true"
import script from "./MyListQuotes.vue?vue&type=script&lang=js"
export * from "./MyListQuotes.vue?vue&type=script&lang=js"

import "./MyListQuotes.vue?vue&type=style&index=0&id=0f3a48ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f3a48ce"]])

export default __exports__